/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import TableHeader from "../../Common/TableHeader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import Loader from "../../Common/Loader";
import Pagination from "../../Common/Pagination";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Select from "react-select";
import SchoolContext from "../../../Context/SchoolContext";

function ActivationsList() {
  const [query, setQuery] = useState("");
  const [school, setSchool] = useState("");
  const [startDate, setStartDate] = useState("");
  const {schoolList} = useContext(SchoolContext);
  const [role, setRole] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [meta, setMeta] = useState([]);
  const [accountActivations, setAccountActivations] = useState([]);

  useEffect(() => {
      if (query || school || startDate || endDate || role) {
          searchAccountActivations();
      } else {
          getAccountActivations(page);
      }
  }, [page]);
  
  const getAccountActivations = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxStudent.listAllActivations(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      }
  };

  const searchAccountActivations = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxStudent.searchAllActivations(page,school,query,startDate,endDate, role);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setAccountActivations(server_response.details.data || []);
      } else {
        setAccountActivations([]);
      } 
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const handleFilter = () => {
    setShowFilter(!showFilter);
  };

  const setActivations = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setStartDate("");
    setEndDate("");
    setPage(1);
    getAccountActivations(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Account Activations List"
          subtitle="List of all the account activations sorted by the most recent"    
        />
        <div class="dropdown">
          <OverlayTrigger placement="top" overlay={
            <Tooltip id="refresh-tooltip">Refresh List</Tooltip>}>
                                          <Link class="dropdown-toggle" onClick={setActivations}> <i class="fas fa-redo-alt text-orange-peel" style={{fontSize:"18px"}}></i></Link>
                                        </OverlayTrigger>
            

          {!showFilter?<OverlayTrigger placement="top" overlay={
            <Tooltip id="refresh-tooltip">Filter</Tooltip>}><Link class="dropdown-toggle" onClick={handleFilter}> <i class="fas fa-filter" style={{color:"black", fontSize:"18px"}}></i></Link></OverlayTrigger>:
          <OverlayTrigger placement="top" overlay={
            <Tooltip id="refresh-tooltip">Hide</Tooltip>}><Link class="dropdown-toggle" onClick={handleFilter}> <i class="fas fa-times" style={{color:"red", fontSize:"18px"}}></i></Link></OverlayTrigger>}

          
        </div>
      </div>
      {showFilter && <form className="mg-t-20" onSubmit={searchAccountActivations}>
        <div className="row gutters-8">
          <div className="col-12-xxxl col-lg-12 col-12 form-group">
            <div className="row">
              <div className="col-lg-4 mt-2">
                <div className="mb-4 form-group border-1">
                    <label htmlFor="">Student Name:</label>
                    <input  onChange={(e) => setQuery(e.target.value)} placeholder="Enter student name..."  style={{border: "1px solid grey"}} value={query} type="text" className="form-control"/>
                </div>
              </div>
              <div className="col-lg-4 mt-2">
                <div className="mb-4 form-group border-1">
                  <label htmlFor="">School Name:</label>
                  <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      placeholder="Select school..."
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                              school === "" ? null
                                : Array.isArray(schoolList) &&
                                  schoolList.find((value) => value.school_id === school)
                            }
                      
                  />
                </div>
              </div>
              <div className="col-lg-4 mt-2">
                <div className="mb-4 form-group border-1">
                  <label htmlFor="">Activated By:</label>
                  <select
                      style={{border: "1px solid grey"}}
                      className="col-12 form-control"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}>
                      <option value="" selected disabled>Select...</option>
                      <option value="2">Admins</option>
                      <option value="3">School Admins</option>
                      <option value="1">Super Admins</option>
                      <option value="7">Vendors</option>
                      <option value="4">Parents</option>
                      <option value="NULL">Others</option>

                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12-xxxl col-lg-12 col-12 form-group">
            <div className="row">
                <div className="col-lg-4">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Start Date:</label>
                        <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">End Date:</label>
                        <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
                    </div>
                </div>
                <div className="col-lg-4 mb-4 d-flex align-items-end">
                    <button 
                        type="button" 
                        className="btn-fill-md text-light bg-dodger-blue" 
                        onClick={searchAccountActivations}>Filter<i class="fas fa-check mg-l-15"></i></button>
                </div>
            </div>
          </div>

          
        </div>
      </form>}
      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Activation Date</th>
                <th scope="col">Student Name</th>
                <th scope="col"> School</th>
                <th scope="col"> Activated By</th>

                </tr>
            </thead>
            <tbody>
                {accountActivations.length > 0 ? (
                    accountActivations.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                        </td>
                        
                        <td>
                            {item.last_name} {item.first_name}
                            <br />
                            <small>{item.username}</small>
                        </td>
                        <td>{item.school_name}</td>
                        <td>{item.activated_by? item.activated_by.full_name :"N/A"}
                        <br />
                        <small>{item.activated_by? item.activated_by.role_name:""}</small>
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                            No account activations yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default ActivationsList;
